import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {Delete} from "@mui/icons-material";
import {MoneyField} from "../../../../../Components/Form/MoneyField";
import { Form } from "../../../../../Components/Form/Form/Form";
import { useForm } from "../../../../../../hooks/use_form_v2";
import { ICustomAmountDetailsFormState } from "./AmountDetailsField";
import { FreeTextField } from "../../../../../Components/Form/FreeTextField";

interface ICustomFormProps {
    value: ICustomAmountDetailsFormState;
    onChange(data: ICustomAmountDetailsFormState): void;
    onDelete(): void;
}

export const CustomForm = ({value, onChange, onDelete}: ICustomFormProps) => {
    const form = useForm<ICustomAmountDetailsFormState>(value);
    const { watchAll, register } = form;

    const handleSubmit = (values: any) => {
        return Promise.resolve();
    };

    React.useEffect(() => {
        onChange(watchAll());
    }, [watchAll()]);

    return (
        <Box sx={{display: 'flex'}}>
            <Box sx={{flexGrow: 1}}>
                <Form form={form} onSubmit={handleSubmit} withSubmitButton={false} component={Box}>
                    <Form.Field type={FreeTextField} {...register('label')} gridProps={{xs: 6}} />
                    <Form.Field type={MoneyField} {...register('value')} gridProps={{xs: 6}} />
                </Form>
            </Box>
            <Box sx={{paddingTop: 1.3, paddingLeft: 0.8, marginRight: -0.8}}>
                <IconButton size="small" color="primary" onClick={onDelete}>
                    <Delete />
                </IconButton>
            </Box>
        </Box>
    );
};
